import styled, { keyframes } from 'styled-components'

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 24px;
  font-family: ${({ theme }) => theme?.typography?.fontFamily || 'Poppins, system-ui, sans-serif'};
  color: ${({ theme }) => theme?.colors?.textPrimary || '#21262D'};
  background:
    radial-gradient(ellipse 80% 60% at 50% -10%, rgba(62, 207, 142, 0.18), transparent 55%),
    ${({ theme }) => theme?.colors?.main || '#f1f5f9'};
`

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  border: 3px solid ${({ theme }) => theme?.colors?.borderDefault || '#E2E8F0'};
  border-top-color: ${({ theme }) => theme?.colors?.action?.primary?.bg || '#3ECF8E'};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

export const LoadingText = styled.div`
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.textMuted || '#8390A2'};
`
